import routes from './routes.tsx';
import { IModuleProps } from '../core/utils/modules.tsx';

export default {
    name: 'forms',
    routes,
} as IModuleProps;
